import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { TutorProfileInfo } from "../../../api/typings/Profiles";

export class ProfileTutorService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = (data: TutorProfileInfo) => {};
}
